<template>
    <div class="container">
        <table class="table">
            <thead>
                <tr>
                    <th v-for="(th, idx) in table.thead" :key="idx">
                        <template v-if="th.name === '选择'||th.name==='select'">
                            <input :id="th.checkid ? th.checkid : randomId"  type="checkbox" v-model="checkall" @change="calCheckedCount">
                            <label :for="th.checkid ? th.checkid :randomId"></label>
                        </template>
                        <template v-else>
                        <span v-if="th.arrange" :class="{'upspan':th.up==true,'downspan':th.up==false,'sel':selth==th.name,'sortspan':th.arrange}" @click="th.arrange?autosort(th):null">{{th.name}}</span>
                        <span v-else>{{th.name}}</span>
                        </template>
                    </th>
                    <th v-if="table.sub"></th>
                </tr>
            </thead>
            <tfoot>
                <tr>
                    <td :colspan="table.thead.length" align="left" >
                      <div class="float-left"><v-page :page="page"></v-page></div>
                      <template v-if="table.tfoot">
                            <template v-for="button in table.tfoot.buttons">
                              <div class="float-right" v-if="button.select">
                                <v-select :options="button.select" @sel="exec(button.change,$event)" :placeholder="button.name" height="14" btn></v-select>
                              </div>
                              <template v-else>
                                <button type="button" class="float-right"
                                :class="{'delete':button.name.indexOf('删')>-1,
                                'remove':button.name.indexOf('移')>-1}"
                                @click="exec(button.event,button.type)"
                                v-show="(button.show ? button.show(checkedItem) : true)">{{button.name}}</button>
                              </template>
                            </template>
                          <span class="float-right" style=" height: 30px;line-height: 30px;margin: 0 10px;min-width: 80px;cursor:pointer" @click="showCheckedItem=true">{{checkedItem&&(checkedItem.length>0 ? $t('components.tablepanel.selected') + checkedItem.length + $t('components.common.tiao') : ' ')}}</span>
                      </template>
                    </td>
                </tr>
            </tfoot>
            <tbody :class="{'limit-max-width':limitWidth}" ref="table" id="table">
                  <template v-for="(tr,index) in table.tbody">
                  <tr>
                    <td v-for="td in table.thead" :style="td.style" v-if="td.show ? td.show() : true">
                        <template v-if="sortable&&td.name==$t('global.sort')"><span class="my-handle">{{tr.sort}}</span></template>
                        <template v-if="td.index">{{index+1}}</template>
                        <template v-if="td.switch"><div class="switch" :class="{'open':tr[td.switch],'close':!tr[td.switch]}" @click="tr[td.event]"><div></div></div></template>
                        <template v-if="td.boo"><font :color="tr[td.boo]?'':'#aaa'">{{tr[td.boo]?(td.true||'是'):(td.false||'否')}}</font></template>
                        <template v-if="td.type"><template v-for="op in td.options" v-if="tr[td.type]==op.value">{{op.name}}</template></template>
                        <template v-if="td.attr">
                          <template v-if="td.link">
                            <a v-if="typeof(td.link)=='function'" @click.prevent="td.link(tr)">{{tr[td.attr] === undefined ? "-" : tr[td.attr]}}</a>
                            <a v-else @click.prevent="$router.push(td.link(tr))">{{tr[td.text] === undefined ? "-" : tr[td.text]}}</a>
                          </template>
                          <template v-else>{{tr[td.attr] === undefined ? "-" : tr[td.attr] | decode}}</template>
                        </template>
                        <template v-if="td.space">{{tr[td.space] === undefined ? "-" : tr[td.space] | space}}</template>
                        <template v-if="td.percent">{{tr[td.percent] === undefined ? "-" : tr[td.percent] | percent}}</template>
                        <span v-if="td.html_attr" v-html="tr[td.html_attr]"></span>
                        <template v-if="td.url"><a :href="tr[td.url]" target="_blank" :title="$t('components.tablepanel.check')">{{tr[td.text] || tr[td.url]}}</a></template>
                        <template v-if="td.description"><span :title="tr[td.description]" style="cursor:pointer">{{tr[td.description] ? (tr[td.description].length>18 ? tr[td.description].substring(0,18) + '...' : tr[td.description]):'-'}}</span></template>
                        <template v-if="td.date">{{tr[td.date] | formatDate('YYYY-MM-DD hh:mm:ss')}}</template>
                        <template v-if="td.dateYMD">{{tr[td.dateYMD] | formatDate('YYYY-MM-DD')}}</template>
                        <template v-if="td.dateHMS">{{tr[td.dateHMS] | formatTimeline('hh:mm:ss')}}</template>
                        <template v-if="td.imgsrc&&tr[td.imgsrc]"><v-img :src="tr[td.imgsrc]" :style="td.style || 'width:40px;height:40px;'" /></template>
                        <template v-if="td.name === '选择'||td.name === 'select'||td.type==='select'">
                            <input :id="randomId + index" type="checkbox" v-model="checkedId" :value="tr.id||tr.code||tr.name" @change="calCheckedCount(tr)" :disabled="td.disabled?td.disabled(tr):null">
                            <label :for="randomId + index"></label>
                        </template>
                        <template v-if="td.textarea">
                          <textarea style="width:500px;height:40px" v-model="tr[td.textarea]"></textarea>
                        </template>
                        <template v-if="td.input">
                          <input type="number"
                          @focus="curTr=JSON.parse(JSON.stringify(tr)),$event.target.select()"
                          @keydown="$event.keyCode===13?(function(){td.save?td.save(tr):null;$event.target.blur()})(tr,$event):null"
                          v-model.number="tr[td.input]" min="0">
                        </template>
                        <template v-if="td.buttons">
                          <template v-for="(button,index) in td.buttons">
                            <template v-if="!button.needAuth || allow(button.id)">
                              <template v-if="button.select">
                                <v-select :options="button.select" @sel="button.change(tr,$event)" :placeholder="button.name" height="14" btn></v-select>
                              </template>
                              <template v-else>
                                <button type="button"
                                v-if="(button.show ? button.show(tr) : true)"
                                :class="{'delete':button.name.indexOf('删')>-1,
                                'remove':button.name.indexOf('移')>-1,
                                }"
                                @click="button.event(tr,button.type,button)"
                                :disabled="(button.disabled ? button.disabled(tr) : null)">
                                {{button.name}}
                                </button>
                              </template>
                            </template>
                          </template>
                        </template>
                    </td>
                    <td v-if="table.sub"><i class="iconfont icon-triangle" @click="toogle($event,index)"></i></td>
                  </tr>
                  <tr v-if="table.sub" ref="tr" style="display:none" class="subtable">
                    <td  :colspan="table.thead.length+1">
                      <table-panel :table="{thead:table.sub.thead,tbody:tr[table.sub.key],tfoot:false}"></table-panel>
                    </td>
                  </tr>
                  </template>
            </tbody>
        </table>
        <pop-up v-model="showCheckedItem">
          <form  class="form-field" style="min-width:500px">
            <h4>{{$t('components.tablepanel.selected')}}</h4>
            <section>
              <div class="tags">
              <span v-for="item,i in checkedItem" @click="checkedItem.splice(i,1)">{{item.name||item.code||item.title||item}}</span>
              </div>
            </section>
          </form>
        </pop-up>
    </div>
</template>

<script>
  import VPage from './vpage.vue'
  import PopUp from './popup.vue'
  import VSelect from './vselect.vue'
  import Sortable from 'sortablejs'
  export default {
    name: "TablePanel",
    components:{VPage,PopUp,VSelect},
    props:{
      data:{
        type:Array,
        default:function(){
          return []
        }
      },//tableStrage
      value:Array,
      table:{
        type:Object,
        default:function () {
           return {
            thead:[],
            tbody:[]
          }
        }
      },
      page:{
        type:Object,
        default:function () {
          return {
            limit:10,
            count:0,
            current:1,
            total:1
          }
        }
      },
      limitWidth:{
        type:Boolean,
        default:true,
      },
      selectedData:{
        type:Array,
        default:function(){
          return []
        }
      },
      sortable:{
        type:Boolean,
        default:false,
      }
    },
    data () {
      return {
        //引用多个table组件id重复的影响
        randomId:'input-' + Math.random(),
        curTr:{},
        allItem:[],
        selth:'',
        pageList:[],
        unpageList:[],
        checkedItem:this.selectedData || [],
        showCheckedItem:false,
      }
    },
    watch:{
      'table.tbody':{
        handler(val) {
          this.checkevent(this.checkedId)
          this.$nextTick(function () {
            if(this.sortable){
              this.creatSort()
            }
          })
        },
        deep: true
      },
      selectedData:function(val){
        this.checkedItem = JSON.parse(JSON.stringify(val))
        this.checkedId = this.checkedItem.map(v=>v.id||v.code||v.name) || []
        this.tbodyRefreshKey=true
      }
    },
    computed: {
      checkedId:{
        get(){
          return this.checkedItem.map(v=>v.id||v.code||v.name) || []
        },
        set(val){
          this.checkevent(val)
        }
      },
      checkall: {
        get () {
          return (this.table.tbody||[]).length>0 ? (this.table.tbody||[]).length === this.pageList.length : false
        },
        set (value) {
          this.pageList = value ? this.table.tbody.map(v=>v.id||v.code||v.name) : []
          this.checkedId = this.unpageList.concat(this.pageList)
        }
      },
    },
    methods:{
      checkevent(val){
        var val = val
        var arr = []
        this.pageList = []
        this.unpageList = []
        val.forEach(v=>{
          var item1 = this.table.tbody.filter(k=>(k.id||k.code||k.name)==v)
          var item2 = this.checkedItem.filter(k=>(k.id||k.code||k.name)==v)
          if(item1.length>0){
            this.pageList.push(v)
            arr.push(item1[0])
          }else{
            arr.push(item2[0])
            this.unpageList.push(v)
          }
        })
        this.checkedItem = arr
      },
      toogle(obj,e){
        var isHide = this.$refs.tr[e].style.display=='none'
        obj.target.style=  isHide?'transform:rotate(90deg)':''
        this.$refs.tr[e].style = isHide?'':'display:none'
      },
      calCheckedCount (v){
        // this.data.reduce((a,b) => a.concat(b),[]).filter(k=>(k.id||k.code||k.name)==(v.id||v.code||v.name)).forEach(s=>s.checked = v.checked)
        // if(val.length>0){
        //   val.forEach(v=>{
        //     this.data.reduce((a,b) => a.concat(b),[]).filter(k=>(k.id||k.code||k.name)==(v.id||v.code||v.name)).forEach(s=>s.checked = true)
        //   })
        // }
        // this.checkedItem = this.data.reduce((a,b) => a.concat(b),[]).filter(val=>val.checked)
      },
      exec (handle,index) {
        handle(this.checkedItem,index)
        //this.table.tbody.forEach(val=>val.checked = null)
      },
      creatSort(){
        var _this = this
        var sortable = Sortable.create(this.$refs.table,{
          handle:'.my-handle',
          onEnd: function (/**Event*/evt) {
            _this.reSort(evt.oldIndex,evt.newIndex);
          }
        })
      },
      reSort(oldIndex,newIndex){
        var data = {};
        document.querySelectorAll('#table>tr').forEach(e=>{
          var oldSort = 0;
          this.table.tbody.forEach((val,index)=>{
            if(index == oldIndex) {
              oldSort = val.sort;
              data.id = val.id;
            }
            if(index == newIndex) {
              data.sort = val.sort;
            }
          })
          if(oldSort < data.sort) {
            data.sort = data.sort + 1;
          }
        })
        this.$emit('sort',data)
      },
      compare(propertyName,up) {
        return function(object1, object2) {
          var value1 = object1[propertyName];
          var value2 = object2[propertyName];
          if (value2 < value1) {
            return up?1:-1;
          } else if (value2 > value1) {
            return up?-1:1;
          } else {
            return 0;
          }
        }
      },
      autosort(data){
        data.up = data.up==undefined?false:!data.up
        this.selth = data.name
        this.$emit('onSort',data);
//        data.up = !data.up
//        this.table.tbody.sort(this.compare(data.attr,data.up))
      }
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/css/varible.less';
.container{
  margin:15px 21px;
}
.limit-max-width td{
  max-width: 250px;
  padding:0 0.5em;
}
button:disabled{
  cursor:not-allowed;
  color:#aaa;
  border-color: #aaa
}
.table input[type="checkbox"]:disabled + label::before{
  background: #eee;
  content:'\2714';
  color:#bbb
}
.chosen{
  background-color: #5F9EDF;
}
.sortable-ghost {
  opacity: 1;
}
.sortable-chosen {
  background: #F4E2C9;
}
.my-handle{
  display: block;
  cursor: move;
  cursor: -webkit-grabbing;
}
.sortspan{
  cursor: pointer;
  position: relative;
}
.sortspan::before{
  content: '';
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #aaa;
  display: inline-block;
  position: absolute;
  top: -1px;
  right: -15px;
}
.sortspan::after{
  content: '';
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #aaa;
  display: inline-block;
  position: absolute;
  bottom: 0;
  right: -15px;
}
.sel.upspan::before{
  border-bottom-color:#0072c5;
}
.sel.downspan::after{
  border-top-color:#0072c5;
}

.table tr.subtable .table tr{
  background: #fff;
}
td>i.icon-right{
  width: 100%;
  display: block;
  height: 40px;
  line-height: 40px;
}
@switch-height: 20px;
.switch{
    width: @switch-height*2;
    height: @switch-height;
    border-radius: @switch-height/2;
    margin: 0 auto;
    div{
      box-shadow: 0px 1px 2px rgba(0,0,0,0.4);
      float: left;
      transition: all 0.3s;
      margin-top: 2px;
      width: @switch-height - 4;
      height: @switch-height - 4;
      border-radius: 50%;
      background: white;
  }
}
.open{
    background: rgba(0,184,0,0.8);
    div{
      margin-left:@switch-height*2-2-(@switch-height - 4);
    }
}
.close{
    background: rgba(0,0,0,0.2);
    div{
        margin-left: 2px;
    }
}
input[type="number"]{
  max-width:40px;
  background: none;
  color:#333;
  text-align: center;
  border:0;
  padding-right: 3px;
  margin-right: 3px;
  border:1px solid lighten(gray,20%);
  display: inline-block;
}
span.editspan{
  position: absolute;
}
input[type="number"] {
   -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tags>a{margin-bottom: 5px;padding: 2px 20px 2px 7px;position: relative;float: left;margin-right: 10px;color:#5289c0;}
.tags>span{margin-bottom: 5px;background: #fff;padding: 2px 20px 2px 7px;position: relative;float: left;margin-right: 10px;border:1px solid #ccc}
.tags>span:after{content: "×";position: absolute;right:5px;top:0;color: #000;cursor: pointer;}
.tags>span:hover{border-color: orange;}
.tags>button{margin-bottom: 5px;padding: 0 10px;position: relative;float: left;color:#5289c0}
</style>
